import { data_entry_view } from "../helper/data_entry_test_";
import { typing_test_view } from "../helper/typing_test_";

const STARTED = 0;
const ONGOING = 1;
const COMPLETED = 2;
const INTERNAL_ERROR = 99;

const initialState = {
  answers: [],
  approximate_time: 0,
  browser_info: "",
  code: "",
  previous_date_time: null,
  current_question_number: 1,
  id_capture_fields: {
    image: null,
  },
  demographic_fields: {},
  demographics: [],
  email_address: "",
  exam_id: 0,
  exam_index: 0,
  exams: [],
  first_name: "",
  is_loading: false,
  job_applying: "",
  key: "",
  lang: "en",
  language: "",
  last_name: "",
  modal_text: "",
  modal_type: "WARNING",
  platform_logo: null,
  client_platform_logo: null,
  progress_percentage: 0,
  progress_label: "Good Luck!!!",
  question_index: 0,
  redirect_url: "",
  dist_url: "",
  candidate_consent: "",
  status: STARTED,
  sessions: [],
  scale_index: 0,
  show_previous_button: false,
  show_modal: false,
  show_modal_close_button: true,
  sport_demographic_fields: {},
  sport_demographics: {},
  start_time: 0,
  time_remaining: 0,
  time_consume_per_question: [],
  is_time_expired: false,
  total_question: 0,
  tester_id: 0,
  view: "notice",
  has_security_features: false,
  has_job_application: false,
  is_certified: false,
  enabled_open_question: false,
  open_questions: [],
  open_questions_answers: [],
  current_oq_number: 0,
  current_oq_answer_text: "",
  is_practice_done: false,
  is_typing_started: false,
  typing_test_result: [],
  typing_test_diff: [],
  data_entry: {
    form_index: 0,
    rotation_count: 0,
    data_index: 0,
  },
  data_entry_data: [],
  data_entry_test_result: [],
  temp_data_entry_data: {
    invoice_number: "",
    date: "",
    product_number: "",
    list_price: "",
    model_number: "",
    cost: "",
    first_name: "",
    last_name: "",
    street_address: "",
    city: "",
    state: "",
    zip_code: "",
  },
  cheat_count: 0,
};

const compute_progress = (current_question_number, total_question) => {
  return Math.floor((current_question_number / total_question) * 100);
};

const get_progress_label = (percentage) => {
  if (percentage < 25) {
    return "Good Luck!!!";
  } else if (percentage >= 25 && percentage < 50) {
    return "Doing Great!!!";
  } else if (percentage >= 50 && percentage < 75) {
    return "Halfway There!!!";
  } else if (percentage >= 75 && percentage < 100) {
    return "Almost Done!!!";
  } else if (percentage === 100) {
    return "Congratulations!!!";
  }
};

export default (state = initialState, action) => {
  let exam_index = state.exam_index;
  let question_index = state.question_index;
  let status = state.status;
  let view = state.view;
  let progress_percentage = state.progress_percentage;
  let progress_label = state.progress_label;
  let today = new Date();
  let current_question_number = state.current_question_number;

  // get the remining time
  const obj_remaining_time = document.getElementById("remaining_time"); // element is in the timer component (Timer.js) hidden input.
  let time_remaining = 0;
  if (obj_remaining_time !== null) {
    time_remaining = parseInt(obj_remaining_time.value);
  }

  let form_index = state.data_entry.form_index;
  let rotation_count = state.data_entry.rotation_count;
  let data_index = state.data_entry.data_index;
  let data_entry_data = state.data_entry_data;

  switch (action.type) {
    case "START":
      return {
        ...state,
        status: ONGOING,
        time_remaining: 0,
        view: "examination",
        previous_date_time: today,
        start_time: Date.now(),
        show_previous_button: true,
      };

    case "SET_NAME":
      return {
        ...state,
        first_name: action.first_name,
        last_name: action.last_name,
        email_address: action.email_address,
        job_applying: action.job_applying,
      };

    case "CHANGE_VIEW":
      return {
        ...state,
        view: action.view,
      };

    case "NEXT_QUESTION":
      // console.dir(state.previous_date_time);
      const time_consume =
        parseInt(today - Date.parse(state.previous_date_time)) / 1000;
      const question_id = state.exams[exam_index].questions[question_index].id;
      const time_consume_per_question = [
        question_id,
        time_consume,
        ...action.choice_ids,
      ];

      const choice_ids = action.choice_ids;
      const previous_response = state.answers[state.answers.length - 1];

      for (const choice_id of choice_ids) {
        if (previous_response === choice_id) {
          return window.location.reload(false);
        }
      }

      question_index += 1;

      // check if end of question, if end of question move to next scale
      if (
        typeof state.exams[exam_index].questions[question_index] === "undefined"
      ) {
        question_index = 0;
        exam_index += 1;
      }

      // if end of instruction/exam set view to completed
      if (typeof state.exams[exam_index] === "undefined") {
        status = COMPLETED;
        view = "completed";
      } else {
        // diplay new instruction
        if (exam_index !== state.exam_index) {
          view = "instruction";
        }
      }

      progress_percentage = compute_progress(
        state.current_question_number + 1,
        state.total_question
      );

      progress_label = get_progress_label(progress_percentage);

      return {
        ...state,
        current_question_number: state.current_question_number + 1,
        previous_date_time: today,
        progress_percentage,
        exam_index,
        question_index,
        progress_label,
        status,
        view,
        time_remaining,
        show_previous_button: true,
        answers: [...state.answers, ...action.choice_ids],
        time_consume_per_question: [
          ...state.time_consume_per_question,
          time_consume_per_question,
        ],
      };

    case "PREVIOUS_QUESTION":
      state.answers.pop();
      state.time_consume_per_question.pop();
      progress_percentage = compute_progress(
        state.current_question_number - 1,
        state.total_question
      );
      progress_label = get_progress_label(progress_percentage);

      if (state.question_index === 0) {
        return {
          ...state,
          view: "instruction",
          show_previous_button: false,
          answers: [...state.answers],
          time_consume_per_question: [...state.time_consume_per_question],
        };
      } else {
        return {
          ...state,
          current_question_number: state.current_question_number - 1,
          progress_percentage,
          progress_label,
          question_index: question_index - 1,
          show_previous_button: false,
          answers: [...state.answers],
          time_consume_per_question: [...state.time_consume_per_question],
        };
      }

    case "SET_SCALES":
      return {
        ...state,
        scales: action.scales,
      };

    case "INITIALIZE_TEST":
      return {
        ...state,
        browser_info: action.browser_info,
        exam_id: action.exam_id,
        tester_id: action.tester_id,
        exams: action.exams,
        demographic_fields: action.demographic_fields,
        sport_demographic_fields: action.sport_demographic_fields,
        sessions: action.sessions,
        total_question: action.total_question,
        approximate_time: action.approximate_time,
        previous_date_time: today,
        redirect_url: action.redirect_url,
        dist_url: action.dist_url,
        candidate_consent: action.candidate_consent,
        platform_logo: action.platform_logo,
        client_platform_logo: action.client_platform_logo,
        has_security_features: action.has_security_features,
        has_job_application: action.has_job_application,
        enabled_open_question: action.enabled_open_question,
        open_questions: action.open_questions,
        is_certified: action.is_certified,
        ...action.last_session_info,
      };

    case "SET_TIME_EXPIRED":
      // time_expired: action.stop_falsek
      return {
        ...state,
        is_time_expired: action.is_time_expired,
      };

    case "SET_KEY_AND_CODE":
      return {
        ...state,
        key: action.key,
        code: action.code,
      };

    case "SET_TESTER_ID":
      return {
        ...state,
        tester_id: action.tester_id,
      };

    case "NEXT_EXAM":
      if (typeof state.exams[exam_index + 1] === "undefined") {
        status = COMPLETED;
        view = "completed";
      } else {
        // compute progress bar
        const scaleTotalQuestion = state.exams[exam_index].questions.length;
        current_question_number =
          current_question_number + (scaleTotalQuestion - question_index);

        exam_index += 1;
        // diplay new instruction
        if (exam_index !== state.exam_index) {
          view = "instruction";
        }
      }

      progress_percentage = compute_progress(
        current_question_number,
        state.total_question
      );
      progress_label = get_progress_label(progress_percentage);

      return {
        ...state,
        current_question_number,
        progress_percentage,
        progress_label,
        exam_index,
        scale_index: 0,
        question_index: 0,
        time_remaining: 0,
        is_time_expired: false,
        view,
      };

    case "SET_REMAINING_TIME":
      return {
        ...state,
        time_remaining,
      };

    case "SET_EXAMINATION_COMPLETED":
      return {
        ...state,
        status: COMPLETED,
        view: "completed",
      };

    case "SET_DEMOGRAPHICS":
      return {
        ...state,
        demographics: action.demographics,
      };

    case "SET_SPORT_DEMOGRAPHICS":
      return {
        ...state,
        sport_demographics: {
          sport: action.sport,
          position: action.position,
          level: action.level,
          gender: action.gender,
        },
      };

    case "SHOW_MODAL":
      return {
        ...state,
        show_modal: true,
        modal_text: action.modal_text,
        modal_type: action.modal_type,
      };

    case "HIDE_MODAL":
      return {
        ...state,
        show_modal: false,
        modal_text: "",
      };

    case "SET_TO_ERROR_STATUS":
      return {
        ...state,
        status: INTERNAL_ERROR,
      };

    case "SET_STATUS":
      return {
        ...state,
        status: action.status,
      };

    case "SET_START_TIME":
      return {
        ...state,
        start_time: action.start_time,
      };

    case "SET_LANGUAGE":
      return {
        ...state,
        lang: action.lang,
      };

    case "SET_ID_CAPTURE_IMAGE":
      return {
        ...state,
        id_capture_fields: {
          ...state.id_capture_fields,
          image: action.image,
        },
      };

    //-- for MS test and computer literacy
    case "NEXT_SECTION":
      const section = action.section;
      const max_loop = 20;
      let counter = 0;

      while (true) {
        counter++;
        question_index++;
        current_question_number++;

        // -- break look if exam ended
        if (
          typeof state.exams[exam_index].questions[question_index] ===
          "undefined"
        ) {
          question_index = 0;
          exam_index++;
          break;
        }
        // -- stop loop move to next section
        if (
          state.exams[exam_index].questions[question_index].section.id !==
          section
        ) {
          break;
        }

        if (counter >= max_loop) {
          break;
        }
      }

      // if end of instruction/exam set view to completed
      if (typeof state.exams[exam_index] === "undefined") {
        status = COMPLETED;
        view = "completed";
      } else {
        // diplay new instruction
        if (exam_index !== state.exam_index) {
          view = "instruction";
        }
      }

      progress_percentage = compute_progress(
        current_question_number,
        state.total_question
      );

      progress_label = get_progress_label(progress_percentage);

      return {
        ...state,
        current_question_number,
        progress_percentage,
        exam_index,
        question_index,
        progress_label,
        status,
        view,
        show_previous_button: true,
      };

    case "SET_IS_CERTIFIED":
      return {
        ...state,
        is_certified: action.is_certified,
      };

    case "SET_OQ_ANSWER":
      return {
        ...state,
        current_oq_answer_text: action.text,
      };

    case "NEXT_OPEN_QUESTION":
      const {
        open_questions,
        open_questions_answers,
        has_job_application,
        current_oq_number,
      } = state;
      const { current_index, answer } = action;

      const last_question =
        typeof open_questions[current_index + 1] === "undefined";
      if (last_question && has_job_application === true) {
        view = "job_application";
      } else if (last_question && has_job_application === false) {
        view = "instruction";
      }

      progress_percentage = compute_progress(
        current_index + 1,
        open_questions.length - 1
      );

      if (current_oq_number === open_questions.length - 1) {
        return {
          ...state,
          current_oq_number: current_index + 1,
          open_questions_answers: [...open_questions_answers, answer],
          view,
          show_previous_button: false,
          progress_percentage: 0,
        };
      }

      return {
        ...state,
        current_oq_number: current_index + 1,
        open_questions_answers: [...open_questions_answers, answer],
        view,
        show_previous_button: true,
        progress_percentage,
      };

    case "PREVIOUS_OPEN_QUESTION":
      state.open_questions_answers.pop();

      progress_percentage = compute_progress(
        action.current_index - 1,
        state.open_questions.length - 1
      );

      if (state.current_oq_number === 0) {
        view = "open_question_instructions";
        return {
          ...state,
          view,
        };
      }

      return {
        ...state,
        current_oq_number: action.current_index - 1,
        open_questions_answers: [...state.open_questions_answers],
        view,
        show_previous_button: false,
        progress_percentage,
      };
    case "SET_IS_PRACTICE_DONE":
      return {
        ...state,
        is_practice_done: action.is_practice_done,
      };

    case "SET_IS_TYPING_STARTED":
      return {
        ...state,
        is_typing_started: action.is_typing_started,
      };

    case "START_TYPING_TEST":
      return {
        ...state,
        status: ONGOING,
        time_remaining: 0,
        view: action.test_name,
        previous_date_time: today,
        show_previous_button: true,
      };
    case "SET_TYPING_TEST_DIFF":
      return {
        ...state,
        typing_test_diff: action.typing_test_diff,
      };
    case "TYPING_TEST_COMPLETED":
      const typing_answer = state.exams[state.exam_index].typing_answer;
      const reference_typing_text =
        state.exams[exam_index].questions[question_index].reference_typing_text;
      const typing_question_id =
        state.exams[exam_index].questions[question_index].id;

      // Calculate the total number of words
      const total_words = Math.ceil(typing_answer.length / 5);

      const reference_text_paragraphs = reference_typing_text.split("\n");
      const typing_answer_paragraphs = typing_answer.split("\n");

      let typing_test_diff = state.typing_test_diff;

      const typing_test_response = typing_test_view(
        reference_text_paragraphs,
        typing_answer_paragraphs,
        typing_test_diff,
        reference_typing_text,
        typing_answer
      );

      return {
        ...state,
        typing_test_result: [
          ...state.typing_test_result,
          {
            question_id: typing_question_id,
            typing_answer: typing_test_response.tempContainer.innerHTML,
            total_number_of_words: total_words,
            total_number_of_errors: typing_test_response.error_count,
            candidate_input: typing_answer,
            exam_name: state.exams[exam_index].name,
          },
        ],
      };
    case "NEXT_DATA_ENTRY_FORM":
      form_index++;

      if (rotation_count !== action.rotation_count) {
        data_index = 0;
      } else {
        data_index++;
      }

      return {
        ...state,
        data_entry: {
          form_index: form_index,
          rotation_count: action.rotation_count,
          data_index: data_index,
        },
      };
    case "RESET_DATA_ENTRY_FORM":
      return {
        ...state,
        data_entry: {
          form_index: 0,
          rotation_count: 0,
          data_index: 0,
        },
        data_entry_data: [],
      };
    case "UPDATE_DATA_ENTRY_DATA":
      if (form_index !== action.form_index) {
        data_entry_data.push(action.data_entry_form_data);
      } else {
        if (data_entry_data.length > 0) {
          data_entry_data.splice(form_index, 1);
          data_entry_data.push(action.data_entry_form_data);
        } else {
          data_entry_data.push(action.data_entry_form_data);
        }
      }

      return {
        ...state,
        data_entry_data,
      };
    case "SET_DATA_ENTRY_DATA":
      return {
        ...state,
        data_entry_data: action.dataEntryData,
        data_entry: action.dataEntryCount,
      };
    case "DATA_ENTRY_TEST_COMPLETED":
      const data_entry_question_id =
        state.exams[exam_index].questions[question_index].id;

      const data_entry_response = data_entry_view(data_entry_data);

      return {
        ...state,
        data_entry_data,
        data_entry_test_result: [
          ...state.data_entry_test_result,
          {
            question_id: data_entry_question_id,
            data_entry_data: JSON.stringify(
              data_entry_response.dataEntryResults
            ),
            total_number_of_keystrokes:
              data_entry_response.totalCountKeystrokes,
            total_characters_typed: data_entry_response.totalCountKeystrokes,
            data_fields_completed: data_entry_response.dataFieldsCompleted,
            data_fields_with_error: data_entry_response.dataFieldsWithError,
            candidate_input: data_entry_data,
            dataEntryErrors: data_entry_response.dataEntryErrors,
            exam_name: state.exams[exam_index].name,
          },
        ],
      };

    case "SET_TEMP_DATA_ENTRY_DATA":
      return {
        ...state,
        temp_data_entry_data: action.tempData,
      };

    case "RESET_TEMP_DATA_ENTRY_DATA":
      return {
        ...state,
        temp_data_entry_data: {
          invoice_number: "",
          date: "",
          product_number: "",
          list_price: "",
          model_number: "",
          cost: "",
          first_name: "",
          last_name: "",
          street_address: "",
          city: "",
          state: "",
          zip_code: "",
        },
      };
    case "SET_CHEAT_COUNT":
      return {
        ...state,
        cheat_count: action.count,
      };
    default:
      return state;
  }
};
